import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { authApi } from '../api/auth';
import { userApi } from '../api/user';

import { Token, RefreshToken } from '../../constants/keys';
import type { WorkspaceMembershipsApi } from '../../types/user';

interface AuthState {
  currentUserId: string;
  currentUserRole: string; // owner, editor
  currentUserWorkspaces: WorkspaceMembershipsApi[];
  avatar: string;
  username: string;
  userCompany: string;
  avatarCompany: string;
}

const initialState: AuthState = {
  currentUserId: '',
  currentUserRole: '',
  currentUserWorkspaces: [],
  avatar: '',
  username: '',
  userCompany: '',
  avatarCompany: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    register: (state, { payload: { username } }: PayloadAction<{ username: string }>) => {
      return { username } as AuthState;
    },
    logout: () => initialState,
    setCompanyName: (state, { payload: { userCompany } }: PayloadAction<{ userCompany: string }>) => {
      state.userCompany = userCompany;
      return state;
    },
    setUserRole: (state, { payload: { userRole } }: PayloadAction<{ userRole: string }>) => {
      state.currentUserRole = userRole;
      return state;
    },
    setAvatar: (state, { payload: { avatar } }: PayloadAction<{ avatar: string }>) => {
      state.avatar = avatar;
      return state;
    },
    setAvatarCompany: (state, { payload: { avatar } }: PayloadAction<{ avatar: string }>) => {
      state.avatarCompany = avatar;
      return state;
    },
    setCurrentUserWorkspaces: (state, { payload: { memberships } }: PayloadAction<{ memberships: WorkspaceMembershipsApi[] }>) => {
      state.currentUserWorkspaces = memberships;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(userApi.endpoints.getCurrentUser.matchFulfilled, (state, { payload }) => {
        const { id, avatar, email, workspace_memberships } = payload;
        state.currentUserId = id;
        state.username = email;
        state.avatar = avatar ?? '';
        state.currentUserWorkspaces = [...workspace_memberships].sort((a, b) =>
          a.workspace.name.localeCompare(b.workspace.name),
        );
      })
      .addMatcher(authApi.endpoints.login.matchFulfilled, (state, { payload }) => {
        const { access, refresh } = payload as { access: string; refresh: string };
        localStorage.setItem(Token, access);
        localStorage.setItem(RefreshToken, refresh);
        // if ('serviceWorker' in navigator) {
        //   navigator.serviceWorker.ready.then((registration) => {
        //     registration.active.postMessage({
        //       type: 'SAVE_TOKEN',
        //       token: access,
        //     });
        //   });
        // }
      })
      .addMatcher(authApi.endpoints.resetPassword.matchFulfilled, (state, { payload }) => {
        const { access, refresh } = payload as { access: string; refresh: string };
        localStorage.setItem(Token, access);
        localStorage.setItem(RefreshToken, refresh);
        // if ('serviceWorker' in navigator) {
        //   navigator.serviceWorker.ready.then((registration) => {
        //     registration.active.postMessage({
        //       type: 'SAVE_TOKEN',
        //       token: access,
        //     });
        //   });
        // }
      });
  },
});

export const {
  logout,
  register,
  setCompanyName,
  setAvatar,
  setAvatarCompany,
  setUserRole,
  setCurrentUserWorkspaces,
} = authSlice.actions;
